const tr = {
	appName: 'resolvo.me',
	welcomeMessage: 'Yeni Yıl Hedeflerinizi Yönetin ve Takip Edin',
	signInToYourAccount: 'Hesabınıza giriş yapın',
	createYourAccount: 'Yeni hesap oluşturun',
	firstName: 'Ad',
	lastName: 'Soyad',
	emailAddress: 'E-posta Adresi',
	password: 'Şifre',
	confirmPassword: 'Şifreyi Onayla',
	signUp: 'Kayıt Ol',
	signIn: 'Giriş Yap',
	processing: 'İşleniyor...',
	dontHaveAccountSignUp: 'Hesabınız yok mu? Kayıt olun',
	alreadyHaveAccountSignIn: 'Zaten bir hesabınız var mı? Giriş yapın',
	resetPassword: 'Şifre Sıfırlama',
	sendResetEmail: 'Şifre Sıfırlama E-postası Gönder',
	sending: 'Gönderiliyor...',
	rememberMe: 'Beni Hatırla',
	forgotPassword: 'Şifrenizi mi unuttunuz?',
	adminDashboard: 'Yönetici Paneli',
	myDashboard: 'Hedeflerim',
	myProfile: 'Profilim',
	settings: 'Ayarlar',
	signOut: 'Çıkış Yap',
	addResolution: 'Hedef Ekle',
	cancel: 'İptal',
	makePrivate: 'Bu hedefi gizli yap (şifrele)',
	encryptionKey: 'Şifreleme Anahtarı',
	enterEncryptionKey: 'Hedefinizi şifrelemek için güvenli bir anahtar girin',
	rememberEncryptionKey: 'Bu anahtarı unutmayın! - gizli hedefinizi görüntülemek için ihtiyacınız olacak',
	type: 'Tür',
	year: 'Yıl',
	resolutionText: 'Hedef Metni',
	exampleCount: 'Örnek: Bu yıl 20 kitap oku',
	exampleBinary: 'Örnek: Yeni bir araba almak',
	exampleMetric: 'Örnek: Yıl sonuna kadar 10 kg ver',
	startValue: 'Başlangıç Değeri',
	targetValue: 'Hedef Değeri',
	unit: 'Birim',
	unitExample: 'Örnek: kg, km, saat, USD',
	exampleStreak: 'Örnek: Her gün 2 lt su iç (günlük kayıt)',
	currentStreak: 'Mevcut Seri',
	longestStreak: 'En Uzun Seri',
	never: 'Hiç',
	measurements: 'Ölçümler',
	lastLogDate: 'Son kayıt tarihi',
	daysInARow: 'günlük seri',
	dailyInARow: 'günlük seri',
	weeklyInARow: 'haftalık seri',
	monthlyInARow: 'aylık seri',
	period: 'Periyot',
	daily: 'Günlük',
	weekly: 'Haftalık',
	monthly: 'Aylık',
	value: 'Değer',
	note: 'Not',
	add: 'Ekle',
	loading: 'Yükleniyor...',
	resolutions: 'Hedefler',
	claimAccount: 'Hesabınızı talep etmelisiniz, böylece hedef ekleyebilirsiniz',
	timeUntilNewYear: 'Yeni Yıla Kalan Süre',
	contactAdmin: 'Hedefleriniz için yönetici ile iletişime geçin...',
	verifyingLink: 'Bağlantınız doğrulanıyor...',
	invalidLink: 'Geçersiz Bağlantı',
	goToLogin: 'Girişe Git',
	completeAccountClaim: 'Hesap Talebini Tamamla',
	emailVerifiedCreatePassword: 'E-posta doğrulandı! Hesabınızı güvence altına almak için bir şifre oluşturun.',
	accountLabel: 'Hesap',
	createPasswordLabel: 'Şifre Oluştur',
	confirmPasswordLabel: 'Şifreyi Onayla',
	enterYourPassword: 'Şifrenizi girin',
	confirmYourPassword: 'Şifrenizi onaylayın',
	creatingAccount: 'Hesap oluşturuluyor...',
	completeClaim: 'Talebi Tamamla',
	backToLogin: 'Girişe Dön',
	passwordMismatch: 'Şifreler eşleşmiyor',
	passwordTooShort: 'Şifre en az 6 karakter olmalıdır',
	invalidOrExpiredLink: 'Geçersiz veya süresi dolmuş doğrulama bağlantısı',
	linkNotFound: 'Doğrulama bağlantısı bulunamadı veya süresi doldu',
	linkExpiredRequestNew: 'Doğrulama bağlantısının süresi doldu. Lütfen yenisini isteyin.',
	accountAlreadyClaimed: 'Bu hesap zaten talep edilmiş',
	failedToCreateAccount: 'Hesap oluşturulamadı. Lütfen tekrar deneyin.',
	claimErrorGeneric: 'Talep tamamlanırken bir hata oluştu',
	resolution: 'hedef',
	total: 'toplam',
	overallProgress: 'Genel İlerleme',
	progress: 'İlerleme',
	completed: 'Tamamlandı',
	complete: 'Tamamla',
	'waiting-completion': 'Tamamlanmayı bekliyor',
	ahead: 'İleride',
	behind: 'Geride',
	'on-track': 'Devam Ediyor',
	failed: 'Başarısız',
	private: 'Gizli',
	decrypt: 'Şifre Çöz',
	delete: 'Sil',
	backToProfile: '← Profile Geri Dön',
	customizeProfile: 'Profilinizi ve tercihlerinizi özelleştirin',
	displayNameHeading: 'Görünen İsim',
	displayNameHelp: 'Adınız profilinizde nasıl görünür',
	enterDisplayName: 'Görünen adınızı girin',
	currentlyShowing: 'Şu anda gösteriliyor',
	emailPreferences: 'E-posta Tercihleri',
	requiredForReceiving: 'E-posta bildirimleri almak için gereklidir',
	weeklyStatusEmail: 'Haftalık Durum E-postası',
	emailRequired: '(E-posta adresi gerekli)',
	timerStyle: 'Sayaç Stili',
	chooseTimer: 'Geri sayım sayacınızın nasıl görünmesini istediğinizi seçin',
	selected: 'Seçildi',
	preview: 'Önizleme:',
	saving: 'Kaydediliyor...',
	saveSettings: 'Ayarları Kaydet',
	count: 'Adet',
	binary: 'Evet/Hayır',
	metric: 'Metrik',
	streak: 'Seri',
	yes: 'Evet',
	no: 'Hayır',
	'timer.months': 'Ay',
	'timer.days': 'Gün',
	'timer.hours': 'Saat',
	'timer.minutes': 'Dakika',
	'timer.seconds': 'Saniye',
	'timer.monthsShort': 'AY',
	'timer.daysShort': 'G',
	'timer.hoursShort': 'SAAT',
	'timer.minutesShort': 'DK',
	'timer.secondsShort': 'SN',
	'timer.monthsShortLower': 'ay',
	'timer.daysShortLower': 'g',
	'timer.hoursShortLower': 's',
	'timer.minutesShortLower': 'dk',
	'timer.secondsShortLower': 'sn',
	'timer.yearEnded': '🎉 Yıl sona erdi!',
	'timer.option.basic.name': 'Minimal Tek Satır',
	'timer.option.basic.desc': 'Temiz ve basit tek satırlık format',
	'timer.option.card.name': 'Renkli Kartlar',
	'timer.option.card.desc': 'Her zaman birim için renkli kartlar',
	'timer.option.clock.name': 'Dijital Saat Stili',
	'timer.option.clock.desc': 'Kalın terminal tarzı dijital saat',
	'timer.option.circular.name': 'İlerleme Halkası Stili',
	'timer.option.circular.desc': 'Modern dairesel ilerleme göstergeleri',
	'timer.option.flip.name': 'FlipCard Animasyonu',
	'timer.option.flip.desc': 'Animasyonlu flip kartlar (yalnızca masaüstü)',
	'timer.option.icon.name': 'Simgelerle Metin',
	'timer.option.icon.desc': 'Emoji simgeleri ve kısaltılmış metin',
	resolutionUpdatedSuccessfully: 'Hedef başarıyla güncellendi!',
	errorUpdatingResolution: 'Hedef güncellenirken hata oluştu',
	failedToUpdateResolution: 'Hedef güncellenemedi',
	settingsUpdatedSuccessfully: 'Ayarlar başarıyla güncellendi!',
	failedToUpdateSettings: 'Ayarlar güncellenemedi',
	settingsSavedSuccessfully: 'Ayarlar başarıyla kaydedildi!',
	failedToSaveSettings: 'Ayarlar kaydedilemedi',
	errorSavingSettings: 'Ayarlar kaydedilirken hata oluştu',
	errorDeletingResolution: 'Hedef silinirken hata oluştu',
	failedToDeleteResolution: 'Hedef silinemedi',
	resolutionDeletedSuccessfully: 'Hedef başarıyla silindi!',
	// Landing page translations
	landingHeroTitle: 'Hedeflerinizi Başarıya Dönüştürün',
	landingHeroSubtitle:
		'resolvo.me, anlamlı hedefler belirlemenize, ilerlemeyi bilinçli şekilde takip etmenize ve hayallerinizi kalıcı alışkanlıklara dönüştürmenize yardımcı olur.',
	landingGetStarted: 'Yolculuğunuza Başlayın',
	landingLearnMore: 'Nasıl Çalışır?',
	landingAndroidComingSoon: '📱 Android uygulaması çok yakında',
	landingAimTitle: 'Neden resolvo.me?',
	landingAimDesc:
		'Net hedefler ve tutarlı takibin gücüne inanıyoruz. resolvo.me, mükemmelliğe değil ilerlemeye inanıp başarı isteyen insanlar için tasarlandı.',
	// Core Missions
	landingMission1Title: 'Şubat Çöküşünü Kır',
	landingMission1Desc:
		"Çoğu Yeni Yıl hedefi Şubat'ta başarısız olur—hedefler yanlış olduğu için değil, takip etmeyi bıraktığımız için.",
	landingMission2Title: 'Niyetleri Eyleme Dönüştür',
	landingMission2Desc:
		'Gerçek değişim sadece vaatlerden gelmez. Günlük seçimlerden, haftalık değerlendirmelerden ve ilerlemenin zamanla nasıl bileşim yaptığını görmekten gelir.',
	landingMission3Title: 'Süreci Basitleştir',
	landingMission3Desc:
		'Hedeflerinizi belirleyin, ilerlemenizi kaydedin, haftalık geri bildirim alın ve gerçekten ne işe yaradığını görün.',
	landingMission4Title: 'Kalıcı Başarıya Ulaşın',
	landingMission4Desc:
		'Kalıcı değişim mükemmellikten değil tutarlılıktan gelir. Günlük seçimler, zamanla yetenek haline dönüşür.',
	landingFeature1Title: 'Birden Fazla Hedef Türü',
	landingFeature1Desc: 'Hedefinize uygun takip yöntemini seçin',
	landingFeature2Title: 'İzleyin & Görselleştirin',
	landingFeature2Desc: 'Grafikler, seriler ve anlamlı içgörüler yoluyla ilerlemenizi görmek',
	landingFeature3Title: 'Haftalık Durum Güncellemeleri',
	landingFeature3Desc: 'Her hafta e-posta özetleriyle hesap veren kalın',
	landingFeature4Title: 'Güvenli & Özel',
	landingFeature4Desc: 'Verileriniz şifrelenir. Hedefleriniz size ait.',
	landingResolutionTypesTitle: 'Hedef Türleri',
	landingResolutionTypesSubtitle: 'Hedefine en uygun formatı seç',
	landingBinaryType: 'Binary (Evet/Hayır)',
	landingBinaryDesc: 'Alışkanlık ve rutinler için basit günlük kontrol',
	landingBinaryExample1: 'Yeni bir araba al',
	landingBinaryExample2: 'Yeni bir iş bul',
	landingCountType: 'Adet',
	landingCountDesc: 'Bir şeyi kaç kez yaptığını takip edin',
	landingCountExample1: 'Bu yıl 20 kitap oku',
	landingCountExample2: 'Bu yıl 50 blog yazısı yaz',
	landingMetricType: 'Metrik',
	landingMetricDesc: 'Başlangıç ve hedef değeri ile sayısal ilerlemeyi takip edin',
	landingMetricExample1: 'Yıl sonuna kadar 10 kg ver',
	landingMetricExample2: 'Bu yıl $5000 tasarruf edin',
	landingStreakType: 'Seri',
	landingStreakDesc: 'Ardışık başarı günleri oluşturun ve motivasyonu artırın',
	landingStreakExample1: 'Her gün 2L su iç',
	landingStreakExample2: 'Romanınız için günde 500 sözcük yazın',
	landingQuote1: 'Başarı, günlük alışkanlıkların ürünüdür—bir kerelik dönüşümün değil.',
	landingQuote1Author: 'James Clear',
	landingQuote2: 'İleriye gitmenin sırrı, başlamaktır.',
	landingQuote2Author: 'Mark Twain',
	landingFeaturesTitle: 'Başarı İçin Oluşturulmuş Özellikler',
	landingFeatureLogging: 'Tek Dokunuşla Kayıt',
	landingFeatureLoggingDesc: 'Saniyeler içinde, her yerden ilerlemenizi kayıt edin',
	landingFeatureHistory: 'İlerleme Geçmişi',
	landingFeatureHistoryDesc: 'Tüm girişlerinizi inceleyin ve ne kadar ilerlediğinizi görün',
	landingFeatureReminders: 'Akıllı Hatırlatıcılar',
	landingFeatureRemindersDesc: 'Sizi harekete geçirmek için isteğe bağlı hatırlatıcılar',
	landingFeatureExport: 'Verilerinizi Dışa Aktarın',
	landingFeatureExportDesc: 'Verilerinizi istediğiniz zaman indirin—bu sizin',
	landingCtaTitle: 'Bu yılı en iyisi yapmaya hazır mısınız?',
	landingCtaDesc: 'Zaten hedeflerine doğru çalışan binlerce insana katılın.',
	landingCtaButton: 'İlk Hedefini Oluştur',
	landingFooterAbout: 'resolvo.me: Basit. Özel. Gerçekten değişmek isteyenler için yapılmıştır.',
	landingFooterContact: 'Sorularınız mı var? Bize ulaşın veya uygulamayı ziyaret edin',
};

export default tr;
